/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import "../SignIn/SignIn.css";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CustomMaterialTable from "../../components/custom/CustomMaterialTable";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import "./EnergyCard.css";
import React, { useState, useEffect, useRef } from "react";
import MDButton from "components/MDButton";
import Loader from "components/custom/Loader";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useMaterialUIController, setMiniSidenav } from "context";
import { Tag } from "antd";
import { Image } from "antd";
import { normalizeSession } from "sessions/utils/normaliseSession";
import "../SignIn/SignIn.css";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import PopAddMain from "./PopAddMain";
import PopReset from "./PopReset";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useSnackbar } from "notistack";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { Generateqr } from "utils/Generateqr";
import { Button } from "antd";
import { useMemo } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import { getSecureUrl } from "utils/secureDownload";
import { extractKeyFromUrl } from "utils/pathHelpers";
import { Modal } from "antd";
import { AutoTooltip } from "utils/Constant";
import { convertUTCtoDubai } from "utils/Constant";
import UnUsedIcon from '../../assets/images/icons/unusable.png'
import TableRefreshButton from "components/Loadable/TableRefreshButton";
import TotalCharger from "../../assets/cms-icons/Totalcharger.png";
import InactiveCharger from "../../assets/cms-icons/InactiveCharger.png";
import ActiveCharger from "../../assets/cms-icons/Activecharger.png";

import {
  CHARGER_STATUS_PRIORITY,
  SESSION_STATUS_PRIORITY,
  sortByStatusPriority,
} from "utils/statusPriority";
import { createSessionColumns } from "sessions";
import { handleSignout } from "utils/Logout";
import { getDecodedUserData } from "utils/Constant";

function Charger_mgmt() {
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabled1, setIsDisabled1] = useState(false);
  const [selected, setSelected] = useState("All Chargers");
  const [sessionorcharger, setSessionorcharger] = useState("charger");
  const [total, setTotal] = useState(0);
  const [activeAC, setActiveAC] = useState(0);
  const [inactiveAC, setInactiveAC] = useState(0);
  const [activeDC, setActiveDC] = useState(0);
  const [inactiveDC, setInactiveDC] = useState(0);
  const [unUsableChargers, setUnUsableChargers] = useState(0);
  const [inactive, setInactive] = useState(0);
  const [columns, setColumns] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const isFirstRender = useRef(true);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrModalLoading, setQrModalLoading] = useState(false);
  const [qrModalUrl, setQrModalUrl] = useState(null);
  const [qrModalTitle, setQrModalTitle] = useState("");
  const [qrModalKey, setQrModalKey] = useState(null);
  const [sessionColumnVisibility, setSessionColumnVisibility] = useState({
    locationName: false,
    startCreatedBy: false,
    stopCreatedBy: false,
    city: false,
    state: false,
    address: false,
    sessionWaitTime: false,
  });

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState([
    {
      id: "createdAt",
      desc: true,
    },
  ]);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [searchText]);

  const handleViewQr = async (row) => {
    const qrKeyOrUrl = row?.qrcodeurl;
    if (!qrKeyOrUrl) return;

    try {
      setQrModalTitle(`${row.charger_id} - ${row.connectorId}`);
      setQrModalOpen(true);
      setQrModalLoading(true);
      setQrModalUrl(null);

      const key = extractKeyFromUrl(qrKeyOrUrl);
      setQrModalKey(key);

      const secureUrl = await getSecureUrl(key, 60);
      setQrModalUrl(secureUrl);
    } catch (e) {
      console.error("Failed to load secure QR:", e);
      enqueueSnackbar("Failed to load QR code", { variant: "error" });
    } finally {
      setQrModalLoading(false);
    }
  };

  const handleDownloadQr = async () => {
    if (!qrModalKey) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}download?key=${encodeURIComponent(
          qrModalKey
        )}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        qrModalKey.split("/").pop() || "qrcode.png"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download QR:", err);
      enqueueSnackbar("Failed to download QR code", { variant: "error" });
    }
  };

  const statusList = [
    "Available",
    "Charging",
    "Preparing",
    "Finishing",
    "SuspendedEVSE",
    "Faulted",
    "Inactive",
    "Reserved",
  ];
  const statusList1 = ["Active", "Completed"];
  const getValues = () => {
    return {
      charger_id: "",
      type: "",
      reason: "",
    };
  };
  const [values, setValues] = useState(getValues);
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;

  const [rows, setRows] = useState([]);
  const onClick = ({ key }) => {
    if (key === "0") {
      setIsLoading(true);
      setSessionorcharger("charger");
      handleDropdownSelect("All Chargers");
      setColumns(column);
    } else {
      setIsLoading(true);
      setSessionorcharger("session");
      handleDropdownSelect("All Sessions");
      setColumns(sessionColumn);
    }
  };

  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };

  const handleActiveFilter = () => {
    const activeStatuses = statusList.filter((status) => status !== "Inactive");
    setColumnFilters([
      {
        id: "status",
        value: activeStatuses,
      },
    ]);
  };
  const StatusLegend = () => (
    <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
      <MDTypography
        variant="caption"
        color="white"
        fontWeight="bold"
        sx={{ opacity: 0.9 }}
      >
        Status:
      </MDTypography>

      <Tag color="green">Available</Tag>
      <Tag color="blue">Charging</Tag>
      <Tag color="yellow">Preparing</Tag>
      <Tag color="purple">Finishing</Tag>
      <Tag color="orange">Suspended</Tag>
      <Tag color="pink">Reserved</Tag>
      <Tag color="red">Faulted</Tag>
      <Tag color="default">Inactive</Tag>
    </MDBox>
  );

  const STATUS_PRIORITY = {
    Available: 1,
    Charging: 2,
    Preparing: 3,
    Finishing: 4,
    Reserved: 5,
    SuspendedEVSE: 6,
    Faulted: 7,
    Inactive: 8,
  };

  const handleInactiveFilter = () => {
    setColumnFilters([
      {
        id: "status",
        value: "Inactive",
      },
    ]);
  };

  const items = [
    {
      label: "All Chargers",
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: "All Sessions",
      key: "2",
    },
  ];
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + "charger-locations/chargers/all",
      withCredentials: true,
    })
      .then((response) => {
        if (response?.data?.success === true) {
          const transformedData = response.data.data.flatMap((location) =>
            location.chargerInfo.flatMap((charger) =>
              charger?.connectors.map((connector) => ({
                charger_id: `${charger?.name}${connector?.connectorId === 1 ? " - A" : connector?.connectorId === 2 ? " - B" : ""}`,
                chargerName: charger?.chargerName || charger?.name || "",
                _id: charger?._id,
                powerOutput: charger?.powerOutput,
                c_type: `${charger?.type}`,
                locationId: location?._id,
                address: location?.address,
                location: location?.locationName,
                l_type: location?.locationType,
                city: location?.city,
                state: location?.state,
                energy_disp: connector?.energyConsumption,
                vendor: charger?.otherDatas?.chargePointVendor || "N/A",
                iccid: charger?.otherDatas?.iccid || "N/A",
                imsi: charger?.otherDatas?.imsi || "N/A",
                model: charger?.otherDatas?.chargePointModel || "N/A",
                type: charger?.type || "N/A",
                subType: charger?.subtype || "N/A",
                firmwareVersion: charger?.otherDatas?.firmwareVersion || "N/A",
                serialNumber: charger?.name || "N/A",
                costPerUnit: charger?.costPerUnit?.amount || "N/A",
                costCurrency: charger?.costPerUnit?.currency || "AED",
                createdAt: charger?.createdAt,
                updatedAt: charger?.updatedAt,
                onboarding_date: charger?.createdAt,
                qrcodeurl: connector?.qrCodeUrl || null,
                status: connector?.status || "Inactive",
                connectorId: connector?.connectorId || 0,
                searchChargerId: `${charger?.name} - ${connector?.connectorId === 1 ? "A" :
                  connector?.connectorId === 2 ? "B" : ""
                  }`,
                last_ping: connector?.lastPing ? connector?.lastPing : "N/A",
                waitTime: connector?.otherData?.waitTime,
              }))
            )
          );

          const sortedData = sortByStatusPriority(
            transformedData,
            CHARGER_STATUS_PRIORITY,
            "last_ping" // optional
          );

          setRows(sortedData);
          setTotal(transformedData.length);
          setInactive(
            transformedData?.filter((row) => row.status === "Inactive" || row.status === "Faulted").length
          );
          setUnUsableChargers(
            transformedData?.filter((row) => row.status === "Inactive" || row.status === "Faulted" || row.status === "SuspendedEVSE").length
          );
          setActiveAC(
            transformedData.filter(
              (row) =>
                row.status !== "Inactive" &&
                row.location === "DTC Marrakesh Street Key room"
            ).length
          );
          setInactiveAC(
            transformedData.filter(
              (row) =>
                row.status === "Inactive" &&
                row.location === "DTC Marrakesh Street Key room"
            ).length
          );
          setActiveDC(
            transformedData.filter(
              (row) =>
                row.status !== "Inactive" &&
                row.location === "Muhaisnah DTC Headquarters"
            ).length
          );
          setInactiveDC(
            transformedData.filter(
              (row) =>
                row.status === "Inactive" &&
                row.location === "Muhaisnah DTC Headquarters"
            ).length
          );

          setIsLoading(false);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
          setIsLoading(false);
        }
        setSelected("All Chargers");
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  }, []);

  const handleDropdownSelect = (selectedValue) => {
    setSelected(selectedValue);
    if (selectedValue === "All Chargers") {
      fetchAllChargers();
      setSessionorcharger("charger");
    } else if (selectedValue === "All Sessions") {
      setSessionorcharger("session");
      fetchAllTransactions();
    }
  };
  const fetchAllChargers = () => {
    axios
      .get(process.env.REACT_APP_BASEURL + "charger-locations/chargers/all", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.success) {
          const transformedData = response.data.data.flatMap((location) =>
            location.chargerInfo.flatMap((charger) =>
              charger?.connectors.map((connector) => ({
                charger_id: charger.name,
                _id: charger._id,
                chargerName: charger?.chargerName || charger?.name || "",
                powerOutput: charger.powerOutput,
                c_type: `${charger.type}`,
                locationId: location._id,
                address: location.address,
                location: location.locationName,
                l_type: location.locationType,
                city: location.city,
                state: location.state,
                energy_disp: connector?.energyConsumption,
                qrcodeurl: connector?.qrCodeUrl || null,
                createdAt: charger.createdAt,
                UpdatedAt: charger.updatedAt,
                onboarding_date: charger.updatedAt,
                type: charger.type,
                subType: charger.subtype,
                otherDatas: charger?.otherDatas || null,
                model: charger?.otherDatas?.model || "N/A",
                vendor: charger?.otherDatas?.vendor || "N/A",
                firmwareVersion: charger?.otherDatas?.firmwareVersion || "N/A",
                imsi: charger?.otherDatas?.imsi || "N/A",
                iccid: charger?.otherDatas?.iccid || "N/A",
                serialNumber: charger?.name || "N/A",
                costPerUnit: charger?.costPerUnit?.amount || "N/A",
                costCurrency: charger?.costPerUnit?.currency || "AED",
                status: connector?.status || "Inactive",
                connectorId: connector?.connectorId || 0,
                last_ping: charger.lastPing ? charger.lastPing : "N/A",
                waitTime: connector?.otherData?.waitTime,
                searchChargerId: `${charger.name} - ${connector.connectorId === 1 ? "A" :
                  connector.connectorId === 2 ? "B" : ""
                  }`,

              }))
            )
          );
          const sortedData = sortByStatusPriority(
            transformedData,
            CHARGER_STATUS_PRIORITY,
            "last_ping" // optional
          );

          setRows(sortedData);
          setIsLoading(false);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };
  const normalizedData = useMemo(
    () => (Array.isArray(rows) ? rows.map(normalizeSession) : []),
    [rows]
  );

  const fetchAllTransactions = () => {
    axios
      .get(
        process.env.REACT_APP_BASEURL +
        `session/pagination/session?page=${page + 1
        }&limit=${pageSize}&sortField=${sorting[0]?.id || ""}&sortOrder=${sorting[0]?.desc ? "desc" : "asc"
        }&search=${debouncedSearchText}`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        if (response.data.success) {
          const updatedRows = response.data.data.map((session) => {
            const metadata = session.metadata || [];

            const firstEntry =
              metadata[0]?.values?.["Energy.Active.Import.Register"];
            const lastEntry =
              metadata[metadata.length - 1]?.values?.[
              "Energy.Active.Import.Register"
              ];
            const firstMeterValue = firstEntry
              ? parseFloat(firstEntry.split(" ")[0])
              : 0;
            const lastMeterValue = lastEntry
              ? parseFloat(lastEntry.split(" ")[0])
              : 0;

            const energyConsumed = session?.energyDispersed;

            const userPhone = session.userPhone || "";
            const chargerName = session?.chargerLocation?.chargerName;

            return {
              ...session,
              status:
                session.status === "Started"
                  ? "Active"
                  : session.status === "Stopped"
                    ? "Completed"
                    : session.status === "Completed"
                      ? "Completed"
                      : session.status,
              energy_disp1: `${energyConsumed}`,
              userPhone: userPhone,
              chargerName: chargerName,
            };
          });
          const sortedRows = sortByStatusPriority(
            updatedRows,
            SESSION_STATUS_PRIORITY,
            "createdAt"
          );

          setRows(sortedRows);
          setIsLoading(false);
          setTotalRows(response?.data?.pagination?.totalRecords);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    fetchAllTransactions();
  }, [page, pageSize, sorting, debouncedSearchText]);

  const handleSearchChange = (event) => {
    setSearchText(event);
    setPage(0);
  };
  const handleReloadSessions = () => {
    setIsLoading(true);
    if (sessionorcharger !== "session")
      fetchAllChargers();
    else
      fetchAllTransactions();
  };

  const handleGenerate = async (row_data, charger_id) => {
    const payload = {
      payload: {
        connectorId: row_data?.connectorId,
        chargerId: charger_id
      },
    };
    const data = await Generateqr("encrypt-param", "POST", payload);
    if (data?.status === true) {
      enqueueSnackbar(data?.message || "QR Code is Generated Successfully!", {
        variant: "success",
      });
      window.location.reload();
    } else {
      enqueueSnackbar(data?.message || "QR Code Generation Failed!", {
        variant: "error",
      });
    }
  };

  const column = useMemo(
    () => [
      {
        header: "Charger Name",
        accessorKey: "chargerName",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        size: 250,
      },
      {
        header: "Status",
        accessorKey: "status",
        filterVariant: "select",
        filterSelectOptions: statusList,

        filterFn: (row, id, filterValue) => {
          if (Array.isArray(filterValue)) {
            return filterValue.includes(row.getValue(id));
          }
          return row
            .getValue(id)
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        },

        align: "center",
        fixed: "true",
        size: 190,
        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },

        Cell: ({ row }) => {
          const status = row.original.status;
          const lastPing = row.original.last_ping;

          const statusColors = {
            Faulted: "red",
            Inactive: "default",
            Available: "green",
            Charging: "blue",
            SuspendedEVSE: "orange",
            Finishing: "purple",
            Reserved: "pink",
            Preparing: "yellow",
          };

          const color = statusColors[status] || "yellow";

          const label = lastPing === "NA" ? "Disconnect" : status;

          return (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              borderRadius="md"
              style={{ flex: 1 }}
            >
              <Tag
                style={{
                  minWidth: "60px",
                  textAlign: "center",
                  display: "inline-block",
                }}
                color={color}
              >
                {label}
              </Tag>
            </MDBox>
          );
        },
      },
      {
        header: "Charger ID",
        accessorKey: "charger_id",
        enableColumnFilter: true,
        align: "center",
        size: 220,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ row }) => {
          const fullChargerId = row?.original?.charger_id;
          const chargerNameOnly = fullChargerId?.split(" - ")[0];

          return (
            <span
              onClick={() =>
                handleEdit({
                  ...row.original,
                  charger_id: chargerNameOnly,
                })
              }
              style={{
                color: "#1E88E5",
                cursor: "pointer",
                textDecoration: "underline",
                whiteSpace: "nowrap",
              }}
            >
              {fullChargerId}
            </span>
          );
        },
      },
      {
        header: "Location Name",
        accessorKey: "location",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        size: 260,
        Cell: ({ cell }) => {
          const locationName = cell.getValue() || " ";
          return <AutoTooltip maxWidth={50}>{locationName}</AutoTooltip>;
        },
      },

      //   {
      //   header: "Total Energy Consumed",
      //   accessorKey: "energy_disp",
      //   align: "center",
      //   muiTableHeadCellProps: {
      //     align: "center",
      //   },
      //   muiTableBodyCellProps: {
      //     align: "center",
      //   },
      //   size:320
      // },

      // {
      //   header: "Onboarding Date",
      //   accessorKey: "onboarding_date",
      //   align: "center",
      //   muiTableHeadCellProps: {
      //     align: "center",
      //   },
      //   muiTableBodyCellProps: {
      //     align: "center",
      //   },
      //   size:270,
      //   Cell: ({ cell }) => {
      //     return convertUTCtoDubai(cell.getValue());
      //   },
      // },

      {
        header: "Last ping",
        accessorKey: "last_ping",
        enableColumnFilter: false,
        align: "center",
        size: 210,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },
      {
        header: "Onboarding Date",
        accessorKey: "onboarding_date",
        enableColumnFilter: false,
        align: "center",
        size: 210,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },
      {
        header: "QR Code",
        accessorKey: "qrcodeurl",
        enableColumnFilter: false,
        align: "center",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ row }) => {
          const hasQr = !!row.original.qrcodeurl;

          if (!hasQr) return "N/A";

          return (
            <MDButton
              size="small"
              variant="outlined"
              onClick={() => handleViewQr(row.original)}
              sx={{
                minWidth: "auto",
                color: "#1976d2",
                textTransform: "none",
                "&:hover": { backgroundColor: "#e3f2fd" },
              }}
            >
              View QR
            </MDButton>
          );
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        pinned: "right",
        size: 190,
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: (row) => {
          const fullChargerId = row?.row?.original?.charger_id;
          const chargerNameOnly = fullChargerId?.split(" - ")[0];
          return(
          <div
            key={`action-cell-${row.row.id}-${sidenavColor}`}
            style={{
              position: "sticky",
              right: "0",
              // backgroundColor:'white',
              // zIndex: '111',
            }}
          >
            {/* {row.row.original.qrcodeurl === null && */}
            <MDButton
              // key={sidenavColor}
              sx={{
                marginLeft: 2,
              }}
              onClick={(e) => handleGenerate(row.row.original, chargerNameOnly)}
              variant="gradient"
              color={sidenavColor}
              // color="info"
              iconOnly
            >
              <img
                src={`${process.env.REACT_APP_AWS_BASEURL}cms-icons/Regenarte+scan+qr+code.svg`}
                alt="QR Code"
                style={{ width: "20px", height: "20px" }}
              />
            </MDButton>
            {/* } */}
          </div>
          )
        },
      },

      {
        header: "Location ID",
        accessorKey: "locationId",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Location Type",
        accessorKey: "l_type",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Address",
        accessorKey: "address",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "City",
        accessorKey: "city",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "State",
        accessorKey: "state",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Vendor",
        accessorKey: "vendor",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Model",
        accessorKey: "model",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Power Output",
        accessorKey: "powerOutput",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Type",
        accessorKey: "type",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Sub Type",
        accessorKey: "subType",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Firmware Version",
        accessorKey: "firmwareVersion",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "IMSI",
        accessorKey: "imsi",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "ICCID",
        accessorKey: "iccid",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Unit Cost",
        accessorKey: "costPerUnit",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ row }) => {
          const costPerUnit = row.original.costPerUnit;
          const currency = row.original.costCurrency || "AED";
          return costPerUnit !== "N/A" ? `${costPerUnit} ${currency}` : "N/A";
        },
      },
      {
        header: "Connector ID",
        accessorKey: "connectorId",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },

      {
        header: "Created Date",
        accessorKey: "createdAt",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },
      {
        header: "Updated Date",
        accessorKey: "updatedAt",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },
    ],
    [sidenavColor]
  );

  const handleTransactionEdit = (row_data) => {
    navigate("/session", {
      state: {
        _id: row_data?._id,
        charger_id: row_data?.charger_id,
        chargerName: row_data?.chargerLocation?.chargerName,
      },
    });
  };

  const driverMetaColumns = [
    {
      header: "Driver ID",
      accessorKey: "userPhone",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Started By",
      accessorKey: "startCreatedBy",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Stopped By",
      accessorKey: "stopCreatedBy",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
  ];

  const sessionColumn = useMemo(() => {
    const baseColumns = createSessionColumns({
      statusColorMap: {
        Active: "blue",
        Completed: "green",
      },
      onSessionClick: handleTransactionEdit,
    });

    const getCol = (key) => baseColumns.find((c) => c.accessorKey === key);

    return [
      getCol("sessionId"),
      {
        header: "Status",
        accessorKey: "status",
        size: 190,
        align: "center",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ cell }) => {
          const val = cell.getValue();
          const color =
            val === "Active" ? "blue" : val === "Completed" ? "green" : "default";
          return <Tag color={color}>{val}</Tag>;
        },
      },

      getCol("chargerId"),
      getCol("chargerName"),
      getCol("duration"),
      getCol("energyFromMeta"),
      getCol('startSOC'),
      getCol('finalSOC'),
      getCol('totalRevenue'),
      getCol("co2Saved"),

      {
        header: "Driver ID",
        size: 220,
        accessorKey: "userPhone",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },

      // getCol("vehicleId"),
      getCol("createdAt"),
      getCol("endTime"),
      // getCol("locationName"),
      // getCol("city"),
      // getCol("state"),
      // getCol("address"),
      getCol("sessionWaitTime"),
    ].filter(Boolean);
  }, [handleTransactionEdit]);

  useEffect(() => {
    setColumns(column);
  }, [sidenavColor]);

  const navigate = useNavigate();

  const handleEdit = (row_data) => {
    if (window.innerWidth < 1200) {
      setMiniSidenav(dispatch, true);
    }
    navigate("/charger/view", { state: row_data });
  };

  const handleDelete = (row_data) => {
    const payload = {
      location_id: row_data?.locationId,
      charger_id: row_data._id,
    };

    axios({
      method: "delete",
      url: process.env.REACT_APP_BASEURL + "charger-locations/delete-charger",
      data: payload,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.success === true) {
          enqueueSnackbar(response.data.message, { variant: "success" });
          navigate("/charger");
          window.location.reload();
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar(
          "Error Occurred while Deleting Charger. Please try again later.",
          { variant: "error" }
        );
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#FFF1CD",
    ...theme.typography.body2,
    padding: theme.spacing(1),

    color: theme.palette.text.secondary,
    boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.15)",
  }));
  const handleStateChange = (newState) => {
    setIsDisabled(newState);
  };
  const handleStateChange1 = (newState) => {
    setIsDisabled1(newState);
  };

  const safeTotal = Number.isFinite(total) && total > 0 ? total : 0;
  const safeInactive =
    Number.isFinite(inactive) && inactive >= 0 ? inactive : 0;
  const activeCount = safeTotal > 0 ? Math.max(0, safeTotal - safeInactive) : 0;
  const activePercent = safeTotal > 0 ? Math.floor((activeCount / safeTotal) * 100) : 0;
  const inactivePercent = safeTotal > 0 ? Math.floor((safeInactive / safeTotal) * 100) : 0;
  const unUsableChargersPercent = safeTotal > 0 ? Math.floor((unUsableChargers / safeTotal) * 100) : 0;
  return (
    <DashboardLayout>
      <PopAddMain
        isDialog={isDisabled}
        onClose={setIsDisabled}
        onStateChange={handleStateChange}
      />
      <PopReset
        isDialog={isDisabled1}
        onClose={setIsDisabled1}
        value={values}
        onStateChange={handleStateChange1}
      />
      <DashboardNavbar />{" "}
      <MDBox mt={2} pt={2} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Total"
                imgicon={TotalCharger}
                count={safeTotal}
                isClickable={true}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                imgicon={InactiveCharger}
                title="Active"
                count={activeCount}
                isClickable={true}
                percentage={{
                  color: "info",
                  amount: `${activePercent}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                imgicon={ActiveCharger}
                title="Inactive"
                count={safeInactive}
                isClickable={true}
                percentage={{
                  color: "success",
                  amount: `${inactivePercent}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                imgicon={UnUsedIcon}
                title="Unusable (Inactive/Fault)"
                count={unUsableChargers}
                isClickable={true}
                percentage={{
                  color: "success",
                  amount: `${unUsableChargersPercent}%`,
                  label: "of total",
                }}

              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Modal
        open={qrModalOpen}
        title={qrModalTitle || "QR Code"}
        footer={null}
        centered
        width={320}
        style={{
          padding: 16,
          textAlign: "center",
        }}
        onCancel={() => {
          setQrModalOpen(false);
          setQrModalUrl(null);
          setQrModalKey(null);
        }}
      >
        {qrModalLoading && (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <Loader />
          </div>
        )}

        {!qrModalLoading && qrModalUrl && (
          <div style={{ textAlign: "center" }}>
            <Image
              src={qrModalUrl}
              alt="QR Code"
              style={{ maxWidth: 160, maxHeight: 160 }}
            />
            <div style={{ marginTop: 16 }}>
              <Button onClick={handleDownloadQr}>Download</Button>
            </div>
          </div>
        )}

        {!qrModalLoading && !qrModalUrl && (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            QR code not available
          </div>
        )}
      </Modal>
      <MDBox mt={8}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={1}
            px={2}
            variant="gradient"
            bgColor={sidenavColor}
            borderRadius="lg"
            coloredShadow={sidenavColor}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Dropdown
                menu={{
                  items,
                  onClick,
                  selectable: true,
                  defaultSelectedKeys: ["0"],
                }}
                trigger={["click"]}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={(e) => e.preventDefault()}>
                  <Space>
                    <MDTypography
                      variant="h6"
                      color="white"
                      style={{
                        fontFamily:
                          '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontWeight: "600",
                      }}
                    >
                      {selected}
                    </MDTypography>
                    <DownOutlined
                      style={{ color: "white", cursor: "pointer" }}
                    />
                  </Space>
                </a>
              </Dropdown>

              <MDBox
                className="admin_btnsHeaderCont"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <MDButton
                  onClick={() => setIsDisabled1(!isDisabled1)}
                  variant="outlined"
                  color="white"
                  size="small"
                >
                  Reset Charger
                </MDButton>

                <MDButton
                  onClick={() => setIsDisabled(!isDisabled)}
                  variant="outlined"
                  color="white"
                  size="small"
                >
                  Start / Stop transaction
                </MDButton>
                <TableRefreshButton
                  onRefresh={handleReloadSessions}
                  loading={isLoading}
                  tooltip={selected === "All Chargers" ? "Reload Chargers" : "Reload Sessions"}
                  customSize={36}
                />
              </MDBox>

            </Grid>
          </MDBox>
          {isLoading ? (
            <Loader />
          ) : (
            <div key={sidenavColor}>
              {/* {sessionorcharger === "charger" && (
                <MDBox
                  px={3}
                  py={1.5}
                  mx={1}
                  borderRadius="xs"
                  sx={{
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <StatusLegend />
                </MDBox>
              )} */}
              {sessionorcharger === "charger" ? (
                <CustomMaterialTable
                  columns={columns}
                  data={rows}
                  darkMode={darkMode}
                  initialState={{
                    columnVisibility: {
                      locationId: false,
                      l_type: false,
                      address: false,
                      city: false,
                      state: false,
                      vendor: false,
                      model: false,
                      powerOutput: false,
                      type: false,
                      subType: false,
                      firmwareVersion: false,
                      imsi: false,
                      iccid: false,
                      connectorId: false,
                      createdAt: false,
                      updatedAt: false,
                      costPerUnit: false,
                    },
                  }}
                />
              ) : (
                <CustomMaterialTablePage
                  columns={sessionColumn}
                  data={normalizedData}
                  darkMode={darkMode}
                  manualPagination={true}
                  rowCount={totalRows}
                  paginationChange={(newPage) => setPagination(newPage)}
                  soringChange={handleSortingChange}
                  page={page}
                  pagesize={pageSize}
                  paginataion={pagination}
                  sorting={sorting}
                  searchText={searchText}
                  searchChange={handleSearchChange}
                  state={{ columnVisibility: sessionColumnVisibility }}
                  onColumnVisibilityChange={setSessionColumnVisibility}
                />
              )}
            </div>
          )}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default Charger_mgmt;
